import React, { Component } from 'react'

import { FillerDiv } from '../StyledComponents/Fillers'
import SettingsRowText from './SettingsRowText'
import SettingsRowEmpty from './SettingsEmptyRow'
import { SelectionNavigator, SelectionNavigatorBackLink, SelectionNavigatorTitle, SelectionBackImage } from '../StyledComponents/Selection'

class Selection extends Component {
    constructor(props) {
        super(props)

        this.closeSelect = this.closeSelect.bind(this)
    }

    /*eslint-disable */
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    closeSelect(newValue) {
        const { closeSelection, type } = this.props

        closeSelection(type, newValue)
    }

    render() {
        const { title, options } = this.props

        const selectOptions = options.map((option, index) => (
            <FillerDiv onClick={() => this.closeSelect(option.value)} key={option.value}>
                <SettingsRowText isFirst={index === 0} title={option.label} />
            </FillerDiv>
        ))

        return (
            <FillerDiv>
                <SelectionNavigator>
                    <SelectionNavigatorBackLink onClick={() => this.closeSelect()}>
                        <SelectionBackImage name="angle-left" size="2x" />
                    </SelectionNavigatorBackLink>
                    <SelectionNavigatorTitle>{title}</SelectionNavigatorTitle>
                </SelectionNavigator>
                <SettingsRowEmpty />
                <FillerDiv>{selectOptions}</FillerDiv>
                <SettingsRowEmpty />
            </FillerDiv>
        )
    }
}

Selection.defaultProps = {
    options: [],
    title: 'Choose...',
}

export default Selection



// WEBPACK FOOTER //
// ./src/components/Settings/Selection.js